module.exports = __webpack_public_path__ + "img/s3-1.f58ee10d.jpg";